import { useCallback } from "react";
import { useSelector } from "react-redux";

import { isNotEmptyString } from "@mapmycustomers/shared";
import { useNonNullableContext } from "@mapmycustomers/shared/util/react";

import UserSetting from "@app/enum/UserSetting";
import { getUserSettingValue } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import appendSignature from "@app/util/email/appendSignature";

import EmailContext from "../EmailContext";

const useAIInsertContent = () => {
  const {
    body: currentBody,
    onAiSubjectSuggestionChange,
    onChange,
    onTemplateChange,
    subject,
    template,
  } = useNonNullableContext(EmailContext);

  const bulkEmailSetting = useSelector((state: RootState) =>
    getUserSettingValue(state, UserSetting.BULK_EMAIL)
  );
  const signatureText = bulkEmailSetting?.signature ? (bulkEmailSetting?.signatureText ?? "") : "";

  return useCallback(
    (aiBody: string, aiSubject?: string) => {
      if (isNotEmptyString(aiBody)) {
        const shouldAppendSignature =
          isNotEmptyString(signatureText) &&
          currentBody.includes(signatureText) &&
          !aiBody.includes(signatureText);
        onChange(shouldAppendSignature ? appendSignature(aiBody, signatureText) : aiBody);
      }

      if (isNotEmptyString(aiSubject) && !subject) {
        onAiSubjectSuggestionChange(aiSubject);
      }

      if (template) {
        onTemplateChange(undefined);
      }
    },
    [
      currentBody,
      onChange,
      onAiSubjectSuggestionChange,
      onTemplateChange,
      signatureText,
      subject,
      template,
    ]
  );
};

export default useAIInsertContent;
